import { Typography } from "@mui/material";
import Article from "../../assets/Article.gif";
import Corindus from "../../assets/Corindus.gif";
import Lung from "../../assets/lung.gif";
import { DivisionImageAboutUs, InfoCompanyContainerAboutUs, InfoCompanyContentAboutUs } from "../../styles/aboutUs";

export function InfoCompanyAboutUs() {
  return (
    <>
    <InfoCompanyContainerAboutUs>

      <Typography variant={"h5"} style={{fontWeight: 'bold', padding: '1%'}}>The idea</Typography>
      <Typography variant="subtitle" style={{padding: '1%'}}>
        Reducing the impact of the world's major diseases.
      </Typography>

      <Typography variant={"h5"} style={{fontWeight: 'bold', padding: '1%'}}>The goal</Typography>
      <Typography variant="subtitle" style={{padding: '1%'}}>
        Together, we improve the health and well-being of all people - sustainably and effectively.
      </Typography>

      <Typography variant={"h5"} style={{fontWeight: 'bold', padding: '1%'}}>The approach</Typography>
      <Typography variant="subtitle" style={{padding: '1%'}}>
        As an open team of global experts, we apply deep clinical knowledge, digital innovation, and data driven insights.
      </Typography>

      <Typography variant={"h5"} style={{fontWeight: 'bold', padding: '1%'}}>Our offer</Typography>
      <Typography variant="subtitle" style={{padding: '1%'}}>
        Let's define the most promising course.
      </Typography>

      <Typography variant="subtitle" style={{padding: '1%', margin: '2%'}}>
        To stay successful in meeting today's challenges, hospitals, and in specific radiology departments, are increasingly focusing on an interdisciplinary, disease-oriented setup across departmental borders. We wnat support these institutions along this journey by being their partner along disease pathways.
        
      </Typography>
      <Typography variant="subtitle" style={{padding: '1%', margin: '2%'}}>
        Already today we cover many clinical topics and tailor our radiology products and solutions along clinical pathways. And with intelligent, digitally connected imaging solutions in diagnosis and therapy, you can improve diagnostic accuracy, plan treatment apotions and guide minimally invasive therapy. With our focus towards the world's major diseases stoke, coronary artery disease, lung and liver cancer, we are committed to support patients in every step of their journey.        
      </Typography>

      <Typography variant={"h5"} style={{fontWeight: 'bold', paddingTop: '5%'}}>Our innovation leadership</Typography>
      <Typography variant="subtitle" style={{padding: '1%'}}>
      We have unique strengths in patient twinning, precision therapy as well as digital, data, and AI that set us apart and enable us to actively shape the transformation of healthcare:
      </Typography>
    </InfoCompanyContainerAboutUs>

    <InfoCompanyContentAboutUs>      
      <DivisionImageAboutUs src={Article}></DivisionImageAboutUs>
      <DivisionImageAboutUs src={Corindus}></DivisionImageAboutUs>
      <DivisionImageAboutUs src={Lung}></DivisionImageAboutUs>
      </InfoCompanyContentAboutUs>
    </>
  );
}
